import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/offcanvas';
// import 'bootstrap/js/src/collapse';
// import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/collapse';
import './swiper';
import './form';
import './zawartosc-pakietu';
import './placowki';


const pakietyInfoFixedElement = document.querySelector('.wp-pakiet-info-fixed')
if (pakietyInfoFixedElement) {
    let boxElement;

    window.addEventListener("load", (event) => {
        boxElement = document.querySelector(".wp-pakiet-info");

        createObserver();
    }, false);

    function createObserver() {
        let observer;

        let options = {
            root: null,
            rootMargin: "-160px"
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(boxElement);
    }

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                pakietyInfoFixedElement.classList.remove('visible')
            } else {
                pakietyInfoFixedElement.classList.add('visible')
            }
        });
    }
}



const configuratorLinkSection = document.querySelectorAll('.wp-block-pakietymedyczne-configurator-link-type');
if (configuratorLinkSection.length > 0) {
    configuratorLinkSection.forEach(section => {
        const allLinks = section.querySelectorAll('a');
        allLinks.forEach(link => {
            link.addEventListener('click', e => {
                let type = section.dataset.type;

                if (type === undefined) {
                    if (section.parentElement.classList.contains('header__menu')) {
                        type = 'headerMenuLink'
                    } else if (section.classList.contains('footer__menu-link')) {
                        type = 'footerMenuLink'
                    }
                }

                if (type !== undefined) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'ClickLinkConf',
                        'ActionName': 'bannerDetail',
                        'ActionInfo': type
                    });
                }
            })
        })
    })
}